import { AxiosPromise } from "axios";

import api from "../../config/api-supplier-config";

export function getStore(): AxiosPromise {
  return api.get("v1/stores", {});
}

export default {
  getStore,
};
